<template>
  <span>
    <img :src="require(`@/${getImage}`)">
  </span>
</template>

<script>
import isMobile from "@/utils/isMobile";

export default {
  name: 'Picture',
  props: {
    imgName: {
      type: String,
      required: true
    },
  },
  computed: {
    getImage() {
      return `theme/images/${isMobile() ? 'mobile' : 'desktop'}/${this.imgName}`
    }
  },
}
</script>
